import React from 'react';
import { Heading } from '@klp/design/Heading';
import { useKostnadsKalkyleContext } from '../context/KostnadsKalkyleProvider';
import type { Theme } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';

const styles = (theme: Theme) => ({
    title: {
        paddingRight: theme.spacing(4),
    },
});

export const KostnadsKalkyleModalTitle = () => {
    const classes = useKlpStyles({}, styles);
    const { prosjektNavn } = useKostnadsKalkyleContext();
    return (
        <Heading
            id="beginningSection"
            klpHeadingLevel="THREE"
            translation="prosjekt.kostnadskalkyle.title.kalkyle"
            translationOptions={{
                prosjektNavn: prosjektNavn,
            }}
            className={classes.title}
        />
    );
};
